export { default } from './es/icons/RarTwoTone';